module.exports = __webpack_public_path__ + "static/media/dev.7bfa16a9.png";